import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface NativeFileDownloadDialogData {
    filename: string;
}

@Component({
    selector: 'app-native-file-download-dialog',
    templateUrl: './native-file-download-dialog.component.html',
    styleUrls: ['./native-file-download-dialog.component.scss'],
    standalone: false,
})
export class NativeFileDownloadDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<NativeFileDownloadDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: NativeFileDownloadDialogData
    ) {}

    cancel() {
        this.dialogRef.close('cancel');
    }
}
